import { API_BASE, INO_API_BASE } from '@/Module/Core/Constant';

export const FAQ_API = {
  GET_LIST: `${INO_API_BASE}/faqs`,
  GET_LIST_OLD: `${API_BASE}/Faq`,
  GET_TYPE_LIST: `${INO_API_BASE}/faq-categories`,
  GET_TYPE_LIST_OLD: `${API_BASE}/Common/GetFaqType`,
  GET_LIST_BY_TYPE_ID_OLD: `${API_BASE}/Faq/GetByTypeId`,
};
